module.exports = __webpack_public_path__ + "static/media/YF78_2.f8b0523a.jpg";